import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from 'react';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import LoadingSpinner from '../assets/LoadingSpinner';
import '../css/OrderHistory.css';
import { db } from "../firebase-config";

const OrderHistory = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

        // Pagination state
        const [currentPage, setCurrentPage] = useState(1);
        const itemsPerPage = 20; // Adjust this value for more/less items per page

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };

  const handleViewClick = (id) => {
    console.log('Viewing order with ID:', id);
    navigate(`/pages/ViewOrderReceipt/${id}`); // Navigate to order detail view
  };

  const showInfo = async () => {
    const information = await Swal.fire({
      text: "Logs expire and will be automatically removed after 14 months of storage",
      icon: 'info',
    });
  }

  useEffect(() => {
    const getOrders = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'orderReceipts'));
        const ordersArray = querySnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            branch: data.branch,
            date: new Date(data.date), // Convert the date string to a Date object
            totalAmount: parseFloat(data.totalAmount), // Convert totalAmount string to a number
            items: data.items
          };
        });

        const currentDate = new Date();

        // Calculate one year ago
        const oneYearAgo = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
  
        // Filter out orders older than 1 year
        const filteredOrders = ordersArray.filter(order => {
          return order.date >= oneYearAgo;
        });
  
        // Delete old orders from Firestore
        const oldOrdersToDelete = ordersArray.filter(order => order.date < oneYearAgo);
  
        // Update state with filtered orders
        setOrders(filteredOrders);
  
        // Delete old orders
        oldOrdersToDelete.forEach(async (oldOrder) => {
          try {
            await deleteDoc(doc(db, 'orderReceipts', oldOrder.id));
            console.log(`Deleted order ${oldOrder.id} older than 1 year`);
          } catch (error) {
            console.error(`Error deleting old order ${oldOrder.id}:`, error);
          }
        });
  

        ordersArray.sort((a, b) => b.date - a.date);

        setOrders(ordersArray);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch orders. Please try again later.');
        console.error('Error fetching orders:', err);
        setLoading(false);
      }
    };
    getOrders();
  }, []);

  // Filter orders based on search and date range
  const filteredOrders = orders.filter(order => {
    const matchesSearch = order.branch.toLowerCase().includes(search.toLowerCase());
    const matchesDateRange = (
      (!dateFrom || order.date >= new Date(dateFrom)) &&
      (!dateTo || order.date <= new Date(dateTo))
    );
    return matchesSearch && matchesDateRange;
  });

       // Calculate paginated data
       const indexOfLastItem = currentPage * itemsPerPage;
       const indexOfFirstItem = indexOfLastItem - itemsPerPage;
       const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
     
       // Total pages
       const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
     
       const handlePageChange = (newPage) => {
         if (newPage >= 1 && newPage <= totalPages) {
           setCurrentPage(newPage);
         }
       };
  

  if (loading) return <LoadingSpinner isVisible={true} />;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <div className="header-orderhistory">
        <h1 className="header-orderhistory">Order Receipt History</h1>
        <button onClick={showInfo} className="info-btn-orderhistory">
              i
            </button>
      </div>
      <div className="container-order-history">
        <div className="top-section-order-history">
          <div className="search-container-order-history">
            <input
              type="text"
              placeholder="Search Branch Name..."
              value={search}
              onChange={handleSearchChange}
              className="search-box-order-history"
            />
            <input
              type="date"
              placeholder="Date From"
              value={dateFrom}
              onChange={handleDateFromChange}
              className="search-box-order-history"
            />
            <h5> to </h5>
            <input
              type="date"
              placeholder="Date To"
              value={dateTo}
              onChange={handleDateToChange}
              className="search-box-order-history"
            />
          </div>
        </div>

        <table className="order-history-table">
          <thead>
            <tr>
              <th>Branch Name</th>
              <th>Date</th>
              <th>Total Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map(order => (
              <tr key={order.id}>
                <td>{order.branch}</td>
                <td>{new Date(order.date).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
          })}</td>
                <td>₱{order.totalAmount}</td> {/* Format totalAmount to 2 decimal places */}
                <td><button onClick={() => handleViewClick(order.id)} className="view-btn-order-history">View</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Pagination Controls */}
      <div className="pagination-controls">
            <button className="paginationButton"
              onClick={() => handlePageChange(1)} 
              disabled={currentPage === 1}
            >
              <HiChevronDoubleLeft />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              <HiChevronLeft />
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronRight />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(totalPages)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronDoubleRight />
            </button>
          </div>
      </div>
    </>
  );
};

export default OrderHistory;